import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CatalogPageShell from "../components/Products/CatalogPageShell.jsx";
import DimensionGrid from "../components/Products/DimensionGrid.jsx";
import ProductGrid from "../components/Products/ProductGrid.jsx";
import BuyerViewGrid from "../components/Products/BuyerViewGrid.jsx";
import InventoryLevelsGrid from "../components/Products/InventoryLevelsGrid.jsx";
import TabNavigation from "../components/TabNavigation.jsx";
import { VARIANT_SPEC } from "../components/Products/variantFields.js";

const TABS = [
    { label: "Products", value: 0 },
    { label: "Variants", value: 1 },
    { label: "Buyer View", value: 2 },
    { label: "Inventory Levels", value: 3 },
];

export default function Products() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [tab, setTab] = useState(() => {
        const fromUrl = parseInt(searchParams.get("t"), 10);
        return TABS.some((item) => item.value === fromUrl) ? fromUrl : 0;
    });

    const changeTab = (_event, next) => {
        setTab(next);
        setSearchParams({ t: String(next) });
    };

    useEffect(() => {
        const raw = searchParams.get("t");
        const fromUrl = parseInt(raw, 10);
        const valid = TABS.some((item) => item.value === fromUrl);
        if (valid) {
            if (fromUrl !== tab) setTab(fromUrl);
            return;
        }
        if (tab !== 0) setTab(0);
        if (raw !== "0") {
            setSearchParams({ t: "0" }, { replace: true });
        }
    }, [searchParams, setSearchParams, tab]);

    return (
        <CatalogPageShell
            title="Products"
            subtitle="SKU list, variants, buyer pricing, and inventory levels by channel."
        >
            <div className="app-page-stack">
                <div style={{ flexShrink: 0 }}>
                    <TabNavigation value={tab} onChange={changeTab} tabs={TABS} />
                </div>
                {tab === 1 ? (
                    <DimensionGrid key="variants" spec={VARIANT_SPEC} />
                ) : tab === 2 ? (
                    <BuyerViewGrid key="buyer-view" />
                ) : tab === 3 ? (
                    <InventoryLevelsGrid key="inventory-levels" />
                ) : (
                    <ProductGrid key="products" />
                )}
            </div>
        </CatalogPageShell>
    );
}
